import { FC } from 'react'
import { ESportsCodes } from 'astra-core/containers/CommonDataProvider'

import { StatsFootball } from './components/StatsFootball'

export const STATS_SPORTS: Partial<Record<ESportsCodes, FC>> = {
  [ESportsCodes.FOOTBALL]: StatsFootball
}
